module.exports = __webpack_public_path__ + "ionicons.19e65b89cee273a249fb.eot";


//////////////////
// WEBPACK FOOTER
// D:/V1/er.web.candidateconsole/node_modules/ionicons/fonts/ionicons.eot?v=2.0.1
// module id = ../../../../ionicons/fonts/ionicons.eot?v=2.0.1
// module chunks = styles